/**
 * Project : workspace
 * File    : Theme.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable


// Material 3 color schemes
private val DarkColorScheme = darkColorScheme(
    primary = ThemeColor.shared().PrimaryColor,
    secondary = ThemeColor.shared().SecondaryColor,
    tertiary = ThemeColor.shared().TertiaryColor
)

private val LightColorScheme = lightColorScheme(
    primary = ThemeColor.shared().PrimaryColor,
    secondary = ThemeColor.shared().SecondaryColor,
    tertiary = ThemeColor.shared().TertiaryColor

)

@Composable
/**
 * Executes the friendly theme operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
fun FriendlyTheme(
    darkTheme: Boolean = false,
    content: @Composable () -> Unit
) {
    val replyColorScheme = when {
        darkTheme -> DarkColorScheme
        else -> LightColorScheme
    }
    MaterialTheme(
        colorScheme = replyColorScheme,
        content = content
    )
}